import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import Logo from "../components/Logo";
import GlassCard from "../components/GlassCard";
import PrimaryButton from "../components/PrimaryButton";

const LinkPractitioner = () => {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const { refresh } = useAuth();

  const submit = async () => {
    setError("");
    if (!code.trim()) return;
    setLoading(true);
    try {
      await api.post("/auth/link-practitioner", { invite_code: code.trim().toUpperCase() });
      await refresh();
      nav("/dashboard", { replace: true });
    } catch (e) {
      setError(e?.response?.data?.detail || "Invalid invite code");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 py-12 gap-8 well-page-enter">
      <Logo size="text-4xl" />
      <GlassCard className="w-full max-w-md text-center">
        <h2 className="text-2xl font-semibold text-[#2A3B32]">Connect with your practitioner</h2>
        <p className="mt-3 text-sm text-[#4A5D52]">
          Enter the invite code your therapist or coach shared with you.
        </p>
        <input
          value={code}
          onChange={(e) => setCode(e.target.value.toUpperCase())}
          placeholder="INVITE CODE"
          maxLength={12}
          className="mt-8 w-full h-[56px] bg-white/50 backdrop-blur-sm border border-white/40 text-[#2A3B32] rounded-[20px] px-4 focus:outline-none focus:ring-2 focus:ring-[#8BA38E] tracking-widest text-center font-semibold"
          data-testid="invite-code-input"
        />
        {error && <p className="mt-3 text-sm text-[#B85C5C]" data-testid="invite-error">{error}</p>}
        <div className="mt-6">
          <PrimaryButton onClick={submit} disabled={loading} data-testid="link-practitioner-submit">
            {loading ? "Linking…" : "Continue"}
          </PrimaryButton>
        </div>
        <button
          onClick={() => nav("/dashboard", { replace: true })}
          className="mt-4 text-xs text-[#8A9C91] underline underline-offset-4"
          data-testid="link-skip-btn"
        >
          Skip for now
        </button>
      </GlassCard>
    </div>
  );
};

export default LinkPractitioner;
